import { Component, Input, OnInit } from '@angular/core';
import { TransportOption, TransportOptionParameterSelection, TransportOptionSelection, TransportOptionsPanelModel } from '../../transport-options-panel.model';
import { TranslationService } from '@sdbn/common';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';



@Component({
  selector: 'app-transport-option-entry',
  templateUrl: './transport-option-entry.component.html',
  styleUrls: ['./transport-option-entry.component.scss'],
  standalone: false
})
export class TransportOptionEntryComponent implements OnInit {

  option: TransportOption;

  @Input('option') set setOption(value: TransportOption) {
    this.option = value;
    this.updateEnablement();
  }

  model: TransportOptionsPanelModel;

  @Input('model') set setModel(value: TransportOptionsPanelModel) {
    this.model = value;
    this.updateEnablement();
  }

  @Input() showInternalTransportOptions = true;

  @Input() showDriverHints = false;

  formGroup = new FormGroup({
    selection: new FormControl(null, []),
    amountOfPallettes: new FormControl(null, []),
    amountOfBoxes: new FormControl(null, []),
    amountInKilogramm: new FormControl(null, []),
    amountInLiter: new FormControl(null, []),
    amountOthers: new FormControl(null, []),
  });

  selection: TransportOptionSelection | undefined;

  constructor(
    public translationService: TranslationService
  ) {

  }

  ngOnInit(): void {

    if (this.option == null || this.model == null) {
      console.error('component is not well initialized, model and option are not allowed to be null');
      return;
    }

    for (const parameter of this.option.parameter) {
      this.formGroup.addControl('parameter_' + parameter.id, new FormControl(null, []));
    }

    this.selection = this.getSelection();
    if (this.selection != null && this.selection.selected) {

      const value = {
        selection: true,
        amountOfPallettes: this.selection.amountOfPallettes,
        amountOfBoxes: this.selection.amountOfBoxes,
        amountInKilogramm: this.selection.amountInKilogramm,
        amountInLiter: this.selection.amountInLiter,
        amountOthers: this.selection.amountOthers,
      };

      for (const parameter of this.selection.parameter) {
        value['parameter_' + parameter.parameterId] = parameter.values;
      }


      this.formGroup.patchValue(value);
      if (this.selection.fixed) {
        this.formGroup.controls.selection.disable();
      }
    }

    this.formGroup.valueChanges.subscribe(value => {

      // Direkter Zugriff über control, da der Wert in value NULL istt, wenn das Feld deaktiviert ist
      this.selection = this.getOrCreateSelection();
      if (this.formGroup.controls.selection.value) {
        this.selection.selected = true;
      } else {
        this.selection.selected = false;
      }
      this.model.dirty = true;

      this.selection.amountOfPallettes = value.amountOfPallettes;
      this.selection.amountOfBoxes = value.amountOfBoxes;
      this.selection.amountInKilogramm = value.amountInKilogramm;
      this.selection.amountInLiter = value.amountInLiter;
      this.selection.amountOthers = value.amountOthers;

      for (const parameter of this.option.parameter) {
        const parameterSelection = this.selection.parameter.find(p => p.parameterId === parameter.id);
        if (!parameterSelection) {
          this.selection.parameter.push(new TransportOptionParameterSelection({ parameterId: parameter.id, values: value['parameter_' + parameter.id] }));
        } else {
          parameterSelection.values = value['parameter_' + parameter.id];
        }
      }

      this.model.validate();
      this.model.notifySelectionChange();
    });



  }

  private updateEnablement() {
    if (this.model && this.option) {
      if (this.model.readOnly) {
        this.formGroup.controls['selection'].disable();
      } else {
        this.formGroup.controls['selection'].enable();
      }
    }
  }

  private getSelection(): TransportOptionSelection | undefined {
    for (const selection of this.model.selection) {
      if (selection.id === this.option.id) {
        return selection;
      }
    }
  }

  private getOrCreateSelection(): TransportOptionSelection {
    let selection = this.getSelection();
    if (selection != null) {
      return selection;
    }
    selection = new TransportOptionSelection({ id: this.option.id });
    this.model.selection.push(selection);
    return selection;
  }


}
